<div id="wrapper">
    <div id="innerWrapper">
     <app-header></app-header>
 
     <router-outlet></router-outlet>
 
    </div>
 
 </div>

 <div id="footer">
    <app-footer></app-footer>
 </div>